import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Vehicle,
  Email,
  Closed,
  Tick,
  plusCircle,
  Noimage,
} from "../../common/imagePath";
import Deliveriescard from "../Modal/DeliveriesCard";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import appcontext, { AppContext } from "../../context/AppContext";
import CustomerSupplierDetailModel from "../Modal/CustomerSupplierDetailModel";
import config from "../../config/config";
import axios from "axios";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../common/Constant";
import Select from "react-select";
import CurrencySymbols from "../../common/CurrencySymbol";
import CustomerConfirm from "../Modal/CustomerConfirm";

function SalesCard({
  callback2,
  callback,
  data,
  shippingaddress,
  onCancel,
  AmountPaid,
  visible,
  salesdeliverydata,
  saleDropdown,
  saleDeliveryOtherSection,
  setSalesDeliveryData,
  setDeliveryFees,
  setSelectedSalesDeliveryData,
}) {
  let customerData = data;
  const token = localStorage.getItem("Token");
  const paramObject = useParams();
  // const [salesDeliveryDetails, setSalesDeliveryDetails] = useState();
  const [salesDeliveryDetails, setSalesDeliveryDetails] = useState();
  const [isSetDelivery, setIsSetDelivery] = useState(
    salesdeliverydata != null && salesdeliverydata.Saleid > 0 ? true : false
  );
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const [fecthdata, setfetchdata] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [newData, setNewData] = useState(data);
  const [show, setShow] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [customerId, setCustomerId] = useState(0);
  const [shippingadd, setshippingadd] = useState([]);
  const [selectedshippingadd, setselectedshippingadd] = useState("");
  const [CustomerPopup, setCustomerPopup] = useState(false);

  //accordian

  const [isAccordionOpen, setAccordionOpen] = useState(false);
  const toggleAccordion = () => {
    setAccordionOpen(!isAccordionOpen);
  };

  const [selectedCustomerAvgAOS, setSelectedCustomerAvgAOS] = useState(0);

  //////

  console.log("newData787878787878798798798", data);

  let supplierAddress =
    (newData?.Address1?.length > 0 ? newData?.Address1 + " " : "") +
    (newData?.Address2?.length > 0 ? newData?.Address2 + ", " : "") +
    (newData?.City?.length > 0 ? newData?.City + ", " : "") +
    (newData?.StateProvince?.length > 0 ? newData?.StateProvince + ", " : "") +
    (newData?.Country?.length > 0 ? newData?.Country + ", " : "") +
    (newData?.Zip > 0 ? newData?.Zip + "" : "");

  const [mailingAddress, setMailingAddress] = useState(supplierAddress);
  const [valueOfInput, setValueOfInput] = useState("");
  //const { mailingAddress, setMailingAddress } = useContext(appcontext);

  useEffect(() => {
    setNewData(data);
    setCustomerId(data?.Id);
    setMailingAddress(supplierAddress);
    setValueOfInput(shippingaddress);
  }, [data, supplierAddress, shippingaddress]);

  useEffect(() => {
    if (data?.Id != undefined) {
      axios
        .get(
          `${config.salesconfigBaseUrl}/sales/ShiipingAdresssbyID?CustomerID=${data?.Id}`,

          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          setshippingadd(res.data.ResponseData);
          console.log(
            res.data.ResponseData?.find((item) => item.IsDefault == 1)?.ID,
            paramObject,
            "854214"
          );
          if (paramObject.id === undefined) {
            const defaultShippingAddress =
              res.data.ResponseData?.find((item) => item.ShippingDefault == 1)
                ?.ID ||
              res.data.ResponseData?.find(
                (item) => Number(item.LastSaleAddressID) > 0
              )?.LastSaleAddressID ||
              "";

            console.log(defaultShippingAddress, "defaultShippingAddress");

            setselectedshippingadd(defaultShippingAddress);
            callback2(defaultShippingAddress);
          } else {
            setselectedshippingadd(shippingaddress);
          }
        })
        .catch((err) => {});
    }
  }, [data, fecthdata, show]);

  useEffect(() => {
    if (paramObject.id === undefined) {
      const savedData = localStorage.getItem("dataAfterDelivery") || "";
      if (savedData == 1) {
        console.log(savedData, "savedData");
        setIsSetDelivery(true);
      }
    }
  }, []);

  const handleClick = () => {
    setValueOfInput(valueOfInput);
    setShowEdit(true);
  };

  const AddAddress = (event) => {
    console.log(event, "454511");

    setselectedshippingadd(event ? event : 0);
    setMailingAddress(valueOfInput);
    setShowEdit(false);
    callback2(event ? event : 0, "");
  };

  const handleAddress = (e) => {
    setValueOfInput(e?.target?.value);
    // setAddValue(e.target.value);
    // setShowEdit(true);
  };

  const handlecress = (e) => {
    if(e === "Ok") {
    onCancel();
    localStorage.removeItem("dataAfterDelivery");
    localStorage.removeItem("DeliveryDraft");
    }
    setCustomerPopup(!CustomerPopup);
  };

  const handlePassDeliveryCardData = (e) => {
    // console.log("customerData === ==> ", customerData);
    console.log("salesdeliverydata =====> ", salesdeliverydata);
    if (salesdeliverydata != null && salesdeliverydata.Saleid > 0) {
      // setSalesDeliveryDetails(salesdeliverydata);
      setSalesDeliveryDetails((prev) => {
        return { ...prev, ...salesdeliverydata };
      });
    } else {
      // setSalesDeliveryDetails(customerData);
      setSalesDeliveryDetails((prev) => {
        return { ...prev, ...customerData };
      });
    }
    setShow(true);
  };

  console.log(salesDeliveryDetails, "salesDeliveryDetails");

  const callbackSalesDelivery = (payload, mappedItem) => {
    callback(payload, mappedItem);
    console.log("callbackSalesDelivery payload ==> 458", payload, mappedItem);
    if (payload == "CancelDelivery") {
      setIsSetDelivery(false);
      setSalesDeliveryData((prev) => {
        return { ...prev, DeliveryFees: 0 };
      });
      setSalesDeliveryDetails((prev) => {
        return { ...prev, DeliveryFees: 0 };
      });
      setDeliveryFees(0);
    } else {
      setIsSetDelivery(true);
      setfetchdata((t) => !t);
      setSalesDeliveryDetails((prev) => {
        return { ...prev, DeliveryFees: payload.DeliveryFees };
      });
      if (paramObject.id === undefined) {
        localStorage.setItem("dataAfterDelivery", 1);
      }
    }
  };

  const HandelCustomerSupplierDetailModel = () => {
    setCustomerId(data?.Id);
    setShowCustomerModal(true);
  };

  const handelDeliveryFee = (value) => {
    setSalesDeliveryData((prev) => {
      return { ...prev, DeliveryFees: value };
    });
    setSalesDeliveryDetails((prev) => {
      return { ...prev, DeliveryFees: value };
    });
    setSelectedSalesDeliveryData((prev) => {
      return { ...prev, DeliveryFees: value };
    });
    setDeliveryFees(value);
    if (paramObject?.id === undefined) {
      const draftFromLocalStorage = JSON.parse(
        localStorage.getItem("DeliveryDraft")
      );

      const updatedLocalValues = {
        ...draftFromLocalStorage,
        deliveryFees: value,
      };
      localStorage.setItem("DeliveryDraft", JSON.stringify(updatedLocalValues));
    }
  };

  console.log(selectedshippingadd, "setValueOfInput");
  console.log(saleDeliveryOtherSection?.DeliveryFees, ".DeliveryFees");

  let usersDropdownOption = [];
  const userDropdown = shippingadd.map((u, i) => {
    usersDropdownOption[i] = { label: u.Address1 + u.Address2, value: u.ID };
  });

  const handleFetchCustAOCAVG = (CustomerID) => {
    if (CustomerID > 0) {
      axios
        .get(
          `${config.salesconfigBaseUrl}/sales/customerAvgAocByCustomer?CustomerID=${CustomerID}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          const responseItem = res.data.ResponseData?.[0]?.TotalAvg;
          console.log(responseItem?.TotalAvg, "selmooonnnnnnn84787878");
  setSelectedCustomerAvgAOS(responseItem)
         
        })
        .catch((err) => {
          console.error("Error fetching Avg AOC:", err);
        });
    }
  };
  
  
    useEffect(() => {
      handleFetchCustAOCAVG(data?.Id);
    }, [data?.Id > 0]);
  return (
    <>
      <div className="">
        <div>
          <div className="row">
            <div className="col-md-2">
              <img
                src={data.Image}
                onError={(e) => {
                  e.currentTarget.src = Noimage;
                }}
                // alt={props.Name}
                className="img-thumbnail rounded-circle"
                width="100px"
                height="105px"
              />
            </div>

            <div className="col-7">
              <div
                // data-bs-target="#CustomerSupplierDetailModel"
                // data-bs-toggle="modal"
                class="text-dark cursor-pointer"
                onClick={() => HandelCustomerSupplierDetailModel()}
              >
                {/* to={`/manage-customers/${data.Id}`} */}
                <span style={{ fontSize: "15px" }}>
                  {data.CompanyName} ({data.FirstName} {data.LastName})
                </span>{" "}
              </div>

              <p className="card-Details">
                {" "}
                Balance:
                {/* {data.OpenBalance} */}
                {CurrencySymbols(
                  Number(data.OpenBalance),
                  { CurrencySymbol },
                  FractionDigits
                )}
              </p>
              <p className="custom-text-green fw-bold card-Details">
                {" "}
                AOS:
                {CurrencySymbols(
                  Number(selectedCustomerAvgAOS),
                  { CurrencySymbol },
                  FractionDigits
                )}
              </p>
              <p className="card-Details"> {data.Email}</p>
            </div>

            <div className="w-3 p-2">
              <Link to={`/manage-customers/${data.Id}`} title="Edit">
                <EditOutlinedIcon className="icon-btn-edit" />
              </Link>
              <Link type="button" onClick={() => setCustomerPopup(true)}>
                <DeleteForeverOutlinedIcon className="icon-btn-delete" />
              </Link>
            </div>
            {/* <p>{props.bio}</p> */}

            {/* This is the code before the accordian */}

            {/* <div className="row">
              <div className="col-12">
                <span>
                  {showEdit ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                      }}
                    >
                      <input
                        id="MailingAddress"
                        name="MailingAddress"
                        placeholder="Mailing Address"
                        className="form-control w-100"
                        style={{ border: "none" }}
                        value={valueOfInput}
                        defaultValue={data.Address1}
                        // onChange={(e) => setValueOfInput(e.target.value)}
                        onChange={(e) => handleAddress(e)}
                      ></input>
                      <button
                        className="btn btn-outline-primary btn-sm m-1"
                        onClick={() => AddAddress()}
                      >
                        <i className="fa fa-check" aria-hidden="true"></i>
                      </button>
                      <button
                        className="btn btn-outline-danger btn-sm m-1"
                        onClick={() => setShowEdit(false)}
                      >
                        <i className="fa fa-times" aria-hidden="true"></i>
                      </button>
                    </div>
                  ) : (
                    <div>
                      <p>
                        <i
                          className="fa fa-map-marker text-danger fa-1x ml-2 p-2"
                          style={{ fontSize: "16px" }}
                        ></i>
                        {mailingAddress}
                        &nbsp;&nbsp;
                        <i
                          className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                          style={{ fontSize: "16px", cursor: "pointer" }}
                          onClick={handleClick}
                        ></i>
                      </p>
                    </div>
                  )}
                </span>
              </div>
            </div> */}
          </div>
          <hr />
          <div className="row">
            {saleDropdown !== 4 && (
              <div className="d-flex align-items-center justify-content-between">
                <Link
                  onClick={(e) => handlePassDeliveryCardData(e)}
                  data-bs-target="#DeliveriesModal"
                  data-bs-toggle="modal"
                  className={isSetDelivery ? "text-success" : ""}
                >
                  <span className="form-label"> Manage Deliveries</span>
                </Link>
                <div>
                  {/* <span>Delivery Fee</span> */}
                  <input
                    type="number"
                    id="DeliveryFees"
                    name="DeliveryFees"
                    placeholder="Delivery Fee"
                    class="form-control form-control-sm"
                    style={{ width: "110px" }}
                    onChange={(e) => handelDeliveryFee(e.target.value)}
                    value={saleDeliveryOtherSection?.DeliveryFees}
                  />
                </div>
                {/* {salesDeliveryDetails && ( */}
                {/* <p> {selectedshippingadd}</p> */}
                <Deliveriescard
                  callback={callbackSalesDelivery}
                  shippingadd={shippingadd}
                  setShippingAddressId={AddAddress}
                  customerid={data?.Id}
                  selectedshippingadd={selectedshippingadd}
                  salesDeliveryDetails={salesDeliveryDetails}
                  salesdeliverydata={salesdeliverydata}
                  saleDeliveryOtherSection={saleDeliveryOtherSection}
                  show={show}
                  handlecloses={() => {
                    setShow(false);
                  }}
                />
                {/* )} */}
                <hr />
              </div>
            )}
          </div>
          <div className="row">
            {/* setting the accordian  */}
            <div className="accordian-item">
              <div
                className="accordion-header"
                style={{ cursor: "pointer" }}
                onClick={toggleAccordion}
              >
                <button
                  class="accordion-button dropdown-toggle"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Shipping Address
                </button>
              </div>
              {/* <div>
                      <span>
                        {showEdit ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              border: "1px solid lightgray",
                              borderRadius: "5px",
                            }}
                          >
                            <input
                              id="MailingAddress"
                              name="MailingAddress"
                              placeholder="Mailing Address"
                              className="form-control w-100"
                              style={{ border: "none" }}
                              defaultValue={valueOfInput}
                              // defaultValue={data.Address1}
                              // onChange={(e) => setValueOfInput(e.target.value)}
                              onChange={(e) => handleAddress(e)}
                            ></input>
                            <button
                              className="btn-outline-success"
                              onClick={() => AddAddress()}
                            >
                              <i className="fa fa-check" aria-hidden="true"></i>
                            </button>
                            <button
                              className="btn-outline-danger"
                              onClick={() => setShowEdit(false)}
                            >
                              <i className="fa fa-times" aria-hidden="true"></i>
                            </button>
                          </div>
                        ) : (
                          <div>
                            <p>
                              <i
                                className="fa fa-map-marker text-danger fa-1x ml-2 p-2"
                                style={{ fontSize: "16px" }}
                              ></i>
                              {valueOfInput}
                              &nbsp;&nbsp;
                              <i
                                className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                style={{
                                  fontSize: "16px",
                                  cursor: "pointer",
                                }}
                                onClick={handleClick}
                              ></i>
                            </p>
                          </div>
                        )}
                      </span>
                    </div> */}

              <div className="accordion">
                <div className="col-md-12">
                  <div>
                    <span>
                      <div>
                        {/* <input
                              id="MailingAddress"
                              name="MailingAddress"
                              placeholder="Mailing Address"
                              className="form-control w-100"
                              style={{ border: "none" }}
                              defaultValue={valueOfInput}
                              // defaultValue={data.Address1}
                              // onChange={(e) => setValueOfInput(e.target.value)}
                              onChange={(e) => handleAddress(e)}
                            ></input> */}
                        <Select
                          options={usersDropdownOption}
                          className="custom-search-select mt-1"
                          value={
                            usersDropdownOption.find(
                              (el) => el.value === selectedshippingadd
                            ) || null
                          }
                          isClearable={true}
                          onChange={(selectedOption) =>
                            AddAddress(
                              selectedOption ? selectedOption?.value : 0
                            )
                          }
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        />

                        {/* <button
                              className="btn-outline-success"
                              onClick={() => AddAddress()}
                            >
                              <i className="fa fa-check" aria-hidden="true"></i>
                            </button>
                            <button
                              className="btn-outline-danger"
                              onClick={() => setShowEdit(false)}
                            >
                              <i className="fa fa-times" aria-hidden="true"></i>
                            </button> */}
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="card-footer">saddas</div> */}
          </div>
        </div>
      </div>
      <CustomerSupplierDetailModel
        id={customerId}
        model="customer"
        show={showCustomerModal}
        handleClose={() => {
          setShowCustomerModal(false);
        }}
      />

      <CustomerConfirm
        open={CustomerPopup}
        handleClose={(e) => handlecress}
        Module={"Customer"}
      />
    </>
  );
}

export default SalesCard;
